import { NgIf } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AddressInputsComponent } from '@components/address-inputs/address-inputs.component';
import { UpsellCardComponent } from '@components/upsell-card/upsell-card.component';
import { QuestionnaireAnswers } from '@enums/questionnaire-answers';
import { UpsellSlugs } from '@enums/upsell-slugs';
import { ConsultationStorageService } from '@services/consultation-storage.service';
import { FormService } from '@services/form.service';

@Component({
  selector: 'app-mens-intimate-wash',
  templateUrl: './mens-intimate-wash.component.html',
  imports: [UpsellCardComponent, AddressInputsComponent, NgIf],
})
export class MensIntimateWashComponent {
  @Input() public htmlTitle: string = '<strong>Important: Prevent Reinfection</strong> and Ensure<br>Lasting Relief';
  @Input() public question: string =
    'We highly recommend including the Mens Intimate Wash to prevent reinfection. Would you like to add it to your order?';

  public readonly slug: UpsellSlugs = UpsellSlugs.MensIntimateWash;
  public addressForm: FormGroup | null = null;

  private consultationStorageService = inject(ConsultationStorageService);
  private formService = inject(FormService);

  /**
   * Retrieves the additional forms to validate if the address form is enabled.
   */
  public get additionalFormsToValidate(): FormGroup[] {
    return this.addressForm ? [this.addressForm] : [];
  }

  /**
   * Store the address form in the local storage service using the current upsell option value.
   */
  public onContinueButtonPressed(optionSelected: string): void {
    this.consultationStorageService.setUpsellAddress(
      this.slug,
      optionSelected === QuestionnaireAnswers.No ? null : this.addressForm.value,
    );
  }

  /**
   * Configures the address form based on the current upsell option value.
   */
  public onOptionSelected(optionSelected: string) {
    optionSelected == this.slug ? this.setAddressForm() : (this.addressForm = null);
  }

  /**
   * Configures the address form
   */
  private setAddressForm(): void {
    this.addressForm = this.formService.address;
    this.addressForm.addControl('streetAddress2', new FormControl(null));
    this.addressForm.patchValue(this.consultationStorageService.address);
  }
}
